import { render, staticRenderFns } from "./document-list.component.vue?vue&type=template&id=4a4b35d8&"
import script from "./document-list.component.vue?vue&type=script&lang=ts&"
export * from "./document-list.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports